import React from "react";
import { Sparkles } from "lucide-react";

const DashboardHeader = ({ title, subtitle }) => {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white px-6 py-3 shadow-sm">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-50 via-white to-indigo-50 opacity-70" />

      {/* Left Accent */}
      <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-cyan-500 to-indigo-600 rounded-l-2xl" />

      <div className="relative flex items-center justify-between">
        {/* Left */}
        <div>
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-500 to-indigo-600 shadow-lg">
              <Sparkles size={20} className="text-white" />
            </div>

            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                {title || "AI Dashboard"}
              </h1>

              {subtitle && (
                <p className="mt-1 text-sm text-slate-500">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Right Badge */}
        <div className="hidden md:flex items-center rounded-full border border-cyan-200 bg-cyan-50 px-4 py-2 text-sm font-semibold text-cyan-700 shadow-sm">
          <Sparkles size={16} className="mr-2 animate-pulse" />
          AI Powered
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;